import QrcodeVue from 'qrcode.vue';
import { createApp, h } from 'vue';
import { jsPDF } from 'jspdf';

export const printSticker = async (
  str: string,
  deliveryInfo: string,
  lockerInfo: string,
  phoneNumber: string
): Promise<void> => {
  const height = 33;
  const width = 100;

  // 1. Create a temporary container
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-9999px';
  document.body.appendChild(container);

  // 2. Rendering a QR code
  const app = createApp({
    render() {
      return h(QrcodeVue, {
        value: str,
        size: 200,
        level: 'H',
        renderAs: 'canvas'
      });
    }
  });

  app.mount(container);
  await new Promise((resolve) => setTimeout(resolve, 100));

  const canvas = container.querySelector('canvas') as HTMLCanvasElement;
  if (!canvas) {
    console.error('QR-код не знайдено');
    return;
  }
  const dataUrl = canvas.toDataURL('image/png');

  // 3. PDF
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [width, height]
  });

  // QR code
  const qrWidth = 20;
  const qrHeight = 20;
  const qrX = 10;
  const qrY = 4;

  doc.addImage(dataUrl, 'PNG', qrX, qrY, qrWidth, qrHeight);

  // Add text under the QR code
  const textX = qrX + qrWidth / 2;
  const textY = qrY + qrHeight + 5;

  doc.setFontSize(6);
  doc.text(str, textX, textY, { align: 'center' });

  // Add text to the right of the QR code (deliveryInfo)
  const deliveryInfoX = qrX + qrWidth + 10;
  const deliveryInfoY = qrY + qrHeight / 3 + 2;

  doc.setFontSize(10);
  doc.text(deliveryInfo, deliveryInfoX, deliveryInfoY);

  // Add text to the right of the QR code (lockerInfo)
  const lockerInfoX = qrX + qrWidth + 10;
  const lockerInfoY = qrY + qrHeight / 2 + 5;

  doc.setFontSize(10);
  doc.text(lockerInfo, lockerInfoX, lockerInfoY);

  // Add text to the right of the QR code (phoneNumber)
  const phoneNumberoX = qrX + qrWidth + 10;
  const phoneNumberY = qrY + qrHeight / 1 + 2;

  doc.setFontSize(10);
  doc.text(phoneNumber, phoneNumberoX, phoneNumberY);

  const blob = doc.output('blob');
  const url = URL.createObjectURL(blob);
  const newWindow = window.open(url);

  // Optional: Clean up memory after the window is closed or after a delay
  if (newWindow) {
    // Try the standard load event
    newWindow.onload = () => {
      newWindow.print();
    };

    // Fallback: If onload doesn't fire (common with PDF viewers),
    // trigger print after a short delay.
    setTimeout(() => {
      if (newWindow && !newWindow.closed) {
        newWindow.print();
      }
    }, 500);
  }

  // Cleaning
  app.unmount();
  document.body.removeChild(container);
};
